import { connect } from 'react-redux';
import { getSearchIsActive } from 'store/reducers/search';
import { getHasMobileHeader } from 'store/reducers/navigation';
import ContentPageLayout from './ContentPageLayout';

const mapStateToProps = (state) => ({
  isSearchActive: getSearchIsActive(state),
  hasMobileHeader: getHasMobileHeader(state),
});

export default connect(mapStateToProps)(ContentPageLayout);
